import { createSelector } from 'reselect';

import { projectsSelector, groupsSelector, environmentTypesSelector, timePeriodsSelector } from './base';
import { settingsSelector } from './settings';
import { getLineDataset, getBarDataset, getViewInfo, shouldAggregate, specificOrFirst } from './helpers';

const getDisplay = createSelector([settingsSelector], settings => settings.changeVolume.display);

const getSelectedSummaryIndex = state => state.newdashboard.changeVolume.get('dataDisplayIndex');
const getEnvironmentType = state => state.newdashboard.changeVolume.get('environmentType');
const getTimePeriod = state => state.newdashboard.changeVolume.get('timePeriod');
export const summariesSelector = state => {
    const summaries = state.newdashboard.changeVolume.get('summaries');
    return summaries ? summaries.toJS() : [];
};

const getGraphType = state => state.newdashboard.changeVolume.get('graphType');

const getData = state => {
    const data = state.newdashboard.changeVolume.get('data');
    return data ? data.toJS() : {};
}

const timePeriodSelector = createSelector([timePeriodsSelector, getTimePeriod], (list, item) => {
    const t = item || list[0];
    return t && t.toJS ? t.toJS() : t;
});

const environmentTypeSelector = createSelector([environmentTypesSelector, getEnvironmentType], (list, item) => {
    const t = item || list[0];
    return t && t.toJS ? t.toJS() : t;
});

export const dataSelector = createSelector([
    getData,
    summariesSelector,
    getSelectedSummaryIndex,
    projectsSelector,
    groupsSelector,
    getGraphType
], (data, summaries, summaryIndex, projects, groups, graphType) => {
    const summary = summaries && summaries.length > 0 ? (summaries.length > summaryIndex ? summaries[summaryIndex] : summaries[0]) : { title: '', isPositive: true };
    switch (graphType) {
        case 'Line':
            return getLineDataset(data, summaryIndex, projects, groups);
        case 'Chart':
            return getBarDataset(data, summary, projects, groups);
        default:
            return null;
    }
});

export const viewInfoSelector = createSelector([getDisplay], getViewInfo);

export const filtersSelector = createSelector([
    timePeriodSelector,
    environmentTypeSelector,
    getGraphType
], (timePeriod, environmentType, graphType) => ({ timePeriod, environmentType, graphType }));

export const summarySelector = createSelector([summariesSelector, getSelectedSummaryIndex], specificOrFirst);

export const loadingSelector = state => state.newdashboard.changeVolume.get('loading');
export const excludedItemsSelector = state => state.newdashboard.changeVolume.get('excludedLegendItems');
export const timePeriodInfoSelector = state => state.newdashboard.changeVolume.get('timePeriodInfo').toJS();



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/selectors/change-volume.js